import * as React from 'react';
import { StackCardInterpolationProps } from '../types';

export default React.createContext<StackCardInterpolationProps | undefined>(
  undefined
);
